import { createContext, useContext, type ReactNode } from 'react';
import type { EstadoAuth } from './api/authApi';

const AuthContext = createContext<EstadoAuth | null>(null);

type ProviderProps = {
  estado: EstadoAuth | null;
  children: ReactNode;
};

export function AuthProvider({ estado, children }: ProviderProps) {
  return <AuthContext.Provider value={estado}>{children}</AuthContext.Provider>;
}

/**
 * Hook que devolve o estado de auth disponível para qualquer tela.
 * Pode retornar null durante a inicialização — o caller deve checar.
 */
export function useEstadoAuth(): EstadoAuth | null {
  return useContext(AuthContext);
}

/**
 * Helper específico para features que dependem de internet (consulta de
 * placa, etc.). Retorna true quando o último contato com o servidor é
 * recente (status 'online') — usar para desabilitar botões.
 */
export function useEstaOnline(): boolean {
  const estado = useEstadoAuth();
  return estado?.status === 'online';
}
